import type { LucideIcon } from "lucide-react";

interface SectionHeaderProps {
  icon: LucideIcon;
  titlu: string;
  descriere: string;
  id: string;
}

export function SectionHeader({ icon: Icon, titlu, descriere, id }: SectionHeaderProps) {
  return (
    <div id={id} className="scroll-mt-28 mb-4 flex items-start gap-3">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand-600 text-white shadow-sm">
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <h2 className="text-base font-semibold leading-snug text-slate-900 sm:text-lg">{titlu}</h2>
        <p className="mt-0.5 text-sm leading-snug text-slate-500">{descriere}</p>
      </div>
    </div>
  );
}
